import OpenCheckoutPlan from './OpenCheckoutPlan';

export default OpenCheckoutPlan;
